/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompleteTransactionReversalRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {CompleteTransactionReversalResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const completeTransactionReversal = (request: CompleteTransactionReversalRequest, options?: CashRequestOptions) => post<CompleteTransactionReversalRequest, CompleteTransactionReversalResponse>("/2.0/cash/complete-transaction-reversal", request, {...options, rejectOnError: true })